"use client";

import { useState } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Dialog, DialogContent, DialogClose } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface Project {
  id: number;
  title: string;
  beforeImage: string;
  afterImage: string;
}
const projects: Project[] = [{
  id: 1,
  title: "Ducati MultiStrada Respray - Before",
  beforeImage: "https://custom-candy.com/wp-content/uploads/2026/06/FINISHED_ducati-repair-respray-complete-1.mp4",
  afterImage: "https://custom-candy.com/wp-content/uploads/2026/06/FINISHED_ducati-repair-respray-complete-1.mp4"
}, {
  id: 2,
  title: "Ducati MultiStrada Respray - High Build Primer",
  beforeImage: "https://custom-candy.com/wp-content/uploads/2026/06/Primed.mp4",
  afterImage: "https://custom-candy.com/wp-content/uploads/2026/06/FINISHED_ducati-repair-respray-complete-1.mp4"
}, {
  id: 3,
  title: "Ducati MultiStrada Respray - Paintwork",
  beforeImage: "https://custom-candy.com/wp-content/uploads/2026/06/FINISHED_ducati-repair-respray-complete-1.mp4",
  afterImage: "https://custom-candy.com/wp-content/uploads/2026/06/FINISHED_ducati-repair-respray-complete-1.mp4"
}, {
  id: 4,
  title: "Ducati MultiStrada Respray - After",
  beforeImage: "https://custom-candy.com/wp-content/uploads/2026/06/FINISHED_ducati-repair-respray-complete-1.mp4",
  afterImage: "https://custom-candy.com/wp-content/uploads/2026/06/FINISHED_ducati-repair-respray-complete-1.mp4"
}];
export default function PortfolioGallery() {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const openLightbox = (index: number) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };
  const goToPrevious = () => {
    setCurrentIndex(prev => prev === 0 ? projects.length - 1 : prev - 1);
  };
  const goToNext = () => {
    setCurrentIndex(prev => prev === projects.length - 1 ? 0 : prev + 1);
  };
  return <section className="w-full bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto max-w-7xl">
        <div ref={ref} className={`mb-12 text-center transition-all duration-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4">
            Portfolio Gallery
          </h2>

          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Explore our Ducati MultiStrada 1000s DS Respray project.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {projects.map((project, index) => <Card key={project.id} className="overflow-hidden cursor-pointer hover:shadow-lg transition-shadow" onClick={() => openLightbox(index)}>
              <div className="relative w-full aspect-video overflow-hidden bg-black">
                <video src={project.beforeImage} className="w-full h-full object-cover" autoPlay muted loop playsInline preload="metadata" />
              </div>

              <div className="p-4">
                <h3 className="text-lg font-semibold text-center">
                  {project.title}
                </h3>
              </div>
            </Card>)}
        </div>
      </div>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-w-6xl w-[calc(100%-2rem)] p-0 bg-black border-none overflow-hidden" showCloseButton={false}>
          <div className="relative">
            <DialogClose asChild>
              <Button variant="ghost" size="icon" className="absolute top-4 right-4 z-10 rounded-full bg-black/50 hover:bg-black/70 text-white">
                <X className="size-5" />
              </Button>
            </DialogClose>

            <div className="flex items-center justify-center min-h-[60vh] p-8">
              <div className="w-full max-w-5xl">
                <div className="relative w-full aspect-video mb-6 overflow-hidden rounded-md bg-black">
                  <video key={projects[currentIndex].beforeImage} src={projects[currentIndex].beforeImage} className="w-full h-full object-contain" controls autoPlay muted loop playsInline preload="auto" />
                </div>

                <h3 className="text-2xl font-semibold text-white text-center mb-8">
                  {projects[currentIndex].title}
                </h3>

                <div className="flex items-center justify-center gap-4">
                  <Button variant="ghost" size="icon" onClick={goToPrevious} className="rounded-full bg-white/10 hover:bg-white/20 text-white">
                    <ChevronLeft className="size-6" />
                  </Button>

                  <span className="text-white text-sm">
                    {currentIndex + 1} / {projects.length}
                  </span>

                  <Button variant="ghost" size="icon" onClick={goToNext} className="rounded-full bg-white/10 hover:bg-white/20 text-white">
                    <ChevronRight className="size-6" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </section>;
}